export function shouldAddImages(images: any) {
    let temp: any = [];
    const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    images.forEach((file: any) => {
        temp.push(validImageTypes.includes(file.type));
    });
    return temp.indexOf(true) != -1
}